import axios from "axios";

export default function updateHoliday({ id, name, startDate, endDate, isActive }) {
  const body = {};
  if (name !== undefined) body.name = name;
  if (startDate !== undefined) body.start_date = startDate;
  if (endDate !== undefined) body.end_date = endDate;
  if (isActive !== undefined) body.is_active = isActive;
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/business-holidays/${id}`, body)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
